import Vue from 'vue'
import VSanitize from 'v-sanitize'

// for default options see https://github.com/apostrophecms/sanitize-html#default-options
Vue.use(VSanitize)
